module.exports = __webpack_public_path__ + "assets/logo-foxgid-white.ddff8a64.svg";